module.exports = __webpack_public_path__ + "img/scene5-1.f0d86b78.png";